import React from "react";
// ANT DESIGN COMPONENTS
import { Switch } from "antd";

function FormInputBooleanSwitch({
  value,
  onChangeSwitch,
  labelName,
  variableName,
  isRequired,
  disabledInput,
}: {
  value: boolean;
  labelName: string;
  onChangeSwitch: (newValue: boolean, inputName: string) => void;
  variableName: string;
  isRequired: boolean;
  disabledInput: boolean;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="col-md-12 mt-3">
      <div className="generalStyles__flex">
        <div className="generalStyles__inputFlexNameLarge">
          {isRequired ? (
            <span className="generalStyles__inputFlexRequired">*</span>
          ) : (
            <span style={{ marginLeft: "8px" }} />
          )}
          <span className="drawer__text">{labelName}</span>
        </div>
        <div className="generalStyles__width100">
          <Switch
            disabled={disabledInput}
            onChange={(e) => {
              onChangeSwitch(e, variableName);
            }}
            checked={value}
          />
        </div>
        <div className="generalStyles__infoTooltipIconBlank" />
      </div>
    </div>
  );
}

export default FormInputBooleanSwitch;
